<template>
  <v-app>
    <v-data-table
      :page="page"
      :pageCount="numberOfPages"
      :options.sync="options"
      :server-items-length="totalItems"
      :headers="headers"
      :items="items"
      :search="search"
      :loading="loading"
      loading-text="Đang tải dữ liệu... Vui lòng chờ"
      :items-per-page="perPage"
      :footer-props="{
        showFirstLastPage: true
      }"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Cơ sở sản xuất</v-toolbar-title>
          <v-badge
            v-show="busId"
            bordered
            left
            color="success"
            :content="countMsg ? countMsg : '0'"
            overlap
            offset-x="20"
            offset-y="20"
            class="mr-2"
          >
            <v-btn
              icon
              @click="showMessageDialog"
              to="/user/business/feedbacks"
            >
              <v-icon>
                mdi-email-outline
              </v-icon>
            </v-btn>
          </v-badge>
          <v-spacer/>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Nhập từ khóa"
            single-line
            hide-details
            clearable
          />
          <v-spacer v-if="!busId"/>
          <v-btn
            color="primary"
            text
            class="mb-2 mr-2"
            @click="showFilterDialog"
          >
            <v-icon class="mr-2">mdi-filter-variant-plus</v-icon>
            <span v-if="$vuetify.breakpoint.lgAndUp">
              tìm nâng cao
            </span>
          </v-btn>
          <FormFilter 
            :showDialog="dialogFilter"
            @confirmed="onFilterConfirmed" 
            @cancelled="onFilterCancelled"
          />
          <v-menu v-if="!busId" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                dark
                class="mb-2 mr-2"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon class="mr-2" small>
                  mdi-arrow-collapse-down
                </v-icon>
                Tải về
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(type, index) in exportTypes"
                :key="index"
                @click="exportData(type)"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{ type.toUpperCase() }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn
            v-if="!busId"
            color="primary"
            dark
            class="mb-2"
            v-on:click="showDialog()"
          >
            <v-icon left>mdi-plus</v-icon>
            thêm mới
          </v-btn>
          <Form 
            :showDialog="dialog" 
            :item="item" 
            @confirmed="onConfirmed" 
            @cancelled="onCancelled"
          />
          <AccountManager 
            :showDialog="dialogAM" 
            :item="item" 
            @confirmed="onAMConfirmed" 
            @cancelled="onAMCancelled"
          />
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="headline">Bạn có chắc bạn muốn xóa mục này?</v-card-title>
              <v-card-actions>
                <v-spacer/>
                <v-btn color="primary darken-1" text @click="closeDelete">Hủy bỏ</v-btn>
                <v-btn color="pink darken-1" text @click="deleteItemConfirm">Đồng ý</v-btn>
                <v-spacer/>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.id`]="{ index }">
        {{ (perPage * (page-1)) +  (index+1) }}
      </template>
      <template v-slot:item.avatar="{ item }">
        <v-img
          v-if="item.avatar"
          :src="`${apiBaseUrl}/uploads/${item.avatar}`"
          lazy-src="@/assets/NoImage.jpg"
          class="ma-2"
          width="120"
        >
          <template v-slot:placeholder>
            <v-row
              class="fill-height ma-0"
              align="center"
              justify="center"
            >
              <v-progress-circular
                indeterminate
                color="green"
              />
            </v-row>
          </template>
        </v-img>
        <v-img
          v-else
          src="@/assets/NoImage.jpg"
          class="ma-2"
          width="120"
        >
        </v-img>
      </template>
      <template v-slot:item.trang_thai="{ item }">
        <span v-if="item.trang_thai==0">Ngừng hoạt động</span>
        <span v-else>Đang hoạt động</span>
      </template>
      <template v-slot:item.actions="{ item }">
        <div style="white-space: nowrap;">
          <v-btn
            icon
            color="primary"
            @click="editItem(item)"
          >
            <v-icon>
              mdi-pencil
            </v-icon>
          </v-btn>
          <v-btn
            v-if="!busId"
            icon
            color="pink"
            @click="deleteItem(item)"
          >
            <v-icon>
              mdi-delete
            </v-icon>
          </v-btn>
        </div>
      </template>
      <template v-slot:no-data>
        <v-btn
          color="primary"
          @click="initialize"
        >
          Tải lại
        </v-btn>
      </template>
    </v-data-table>
  </v-app>
</template>
<script>
  import Form from '@/views/admin/businesses/Form';
  import AccountManager from '@/views/admin/businesses/AM';
  import FormFilter from '@/views/admin/businesses/Filter';
  import FileSevice from '@/services/File';
  import { mapState } from 'vuex';
  export default {
    components: {
      Form,
      AccountManager,
      FormFilter
    },
    props: {
      busId: {
        type: Number
      }
    },
    data: () => ({
      loading: false,
      dialog: false,
      dialogAM: false,
      dialogDelete: false,
      dialogFilter: false,
      search: '',
      headers: [
        { text: 'STT', value: 'id' },
        { text: 'Ảnh', value: 'avatar' },
        { text: 'Tên cơ sở', value: 'ten_co_so' },
        { text: 'Loại', value: 'business_type.ten_loai' },
        { text: 'Địa chỉ', value: 'dia_chi' },
        { text: 'Điện thoại', value: 'so_dien_thoai' },
        { text: 'Người liên hệ', value: 'lien_he' },
        { text: 'Tình trạng', value: 'trang_thai' },
        { 
          align: 'right', 
          text: 'Thao tác', 
          value: 'actions', 
          sortable: false 
        },
      ],
      exportTypes: ['pdf', 'xls', 'xlsx', 'docx'],
      page: 1,
      totalItems: 0,
      numberOfPages: 0,
      perPage: 10,
      items: [],
      options: {},
      editedIndex: -1,
      item: {},
      countMsg: 0,
      messageDialog: false,
      filter: {

      }
    }),
    computed: {
      ...mapState([
        'config'
      ]),
      formTitle () {
        return this.editedIndex === -1 ? 'thêm mới' : 'cập nhật';
      },
      apiBaseUrl() {
        return this.config.beUrl;
      }
    },
    watch: {
      options: {
        handler() {
          this.initialize();
        },
      },
      search(){
        this.initialize();
      }
    },
    mounted () {
      if(this.$route.params.show){
        this.showDialog();
      }
      if(this.busId){
        this.countMessageOfBuss();
      }
    },
    methods: {
      initialize () {
        this.loading = true;
        let url = "api/v1/businesses";
        if(this.busId){
          url = `api/v1/businesses/${this.busId}`;
        }
        const { page, itemsPerPage } = this.options;
        let pageNumber = page;
        let request = {
          params: {
            size: itemsPerPage,
            page: pageNumber,
            type: this.filter.loai,
            area: this.filter.khuvuc,
            status: this.filter.tinhtrang,
            keyword: this.search
          }
        };
        axios.get(url, request)
          .then(response => {
            if(this.busId){
              this.items.push(response.data);
              this.totalItems = 1;
              this.numberOfPages = 1;
            } else {
              this.items = response.data.data;
              this.totalItems = response.data.total;
              this.numberOfPages = response.data.to;
              this.page = response.data.current_page;
              this.perPage = response.data.per_page;
            }
            this.loading = false;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      showDialog(item=null){
        this.item = item||{};
        this.dialog = true;
      },
      onConfirmed(item) {
        this.dialog = false;
        this.initialize();
      },
      onCancelled () {
        this.dialog = false;
      },
      // AM dialog
      showAMDialog(item=null){
        this.item = item||{};
        this.dialogAM = true;
      },
      onAMConfirmed() {
        this.dialogAM = false;
      },
      onAMCancelled () {
        this.dialogAM = false;
      },
      editItem (item) {
        this.editedIndex = this.items.indexOf(item);
        this.item = Object.assign({}, item);
        this.dialog = true;
      },
      deleteItem (item) {
        this.editedIndex = this.items.indexOf(item);
        this.item = Object.assign({}, item);
        this.dialogDelete = true;
      },
      deleteItemConfirm () {
        const app = this;
        axios.delete(`api/v1/businesses/${app.item.id}`)
          .then(function (resp) {
            app.items = app.items.filter(val => val.id !== app.item.id);
            app.closeDelete();
          }).catch(function (error) {
            console.log(error);
          });
      },
      close () {
        this.dialog = false;
        this.$nextTick(() => {
          this.item = Object.assign({}, this.item);
          this.editedIndex = -1;
        })
      },
      closeDelete () {
        this.dialogDelete = false;
        this.$nextTick(() => {
          this.item = Object.assign({}, this.item);
          this.editedIndex = -1;
        })
      },
      exportData(type){
        const app = this;
        app.loading=true;
        let params = {
          namereport: 'co_so',
          export_type: type
        };
        axios.post('api/v1/export', params, {responseType: 'arraybuffer'})
          .then(function (response) {
            FileSevice.download(response.data, `co_so.${type}`);
            app.loading=false;
          }).catch(function (error) {
            console.log(error);
          });
      },
      countMessageOfBuss(){
        axios.get(`api/v1/businesses-get-message/${this.busId}`)
          .then(response => {
            if(response.data){
              this.countMsg = response.data.length;
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      showMessageDialog(item=null){
        this.messageDialog = true;
      },
      onMessageConfirmed(item) {
        this.messageDialog = false;
      },
      onMessageCancelled() {
        this.messageDialog = false;
      },
      showFilterDialog(){
        this.dialogFilter = true;
      },
      onFilterConfirmed(filter) {
        this.filter=filter;
        this.initialize();
        this.dialogFilter = false;
      },
      onFilterCancelled () {
        this.dialogFilter = false;
      },
    }
  }
</script>